import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6754fcd0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-container d-flex" }
const _hoisted_2 = { class: "image-container" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "heading-container" }




export default /*#__PURE__*/_defineComponent({
  __name: 'ContractVehiclesBannerComponent',
  props: {
    imageSrc: {},
    heading: {},
    subheading: {}
  },
  setup(__props: any) {

const props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: require(`@/assets/contract vehicles/${_ctx.imageSrc}`),
        alt: "Banner Image",
        class: "main-img"
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.heading), 1)
  ]))
}
}

})